import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormSocialAuditComponent } from './form-social-audit.component';
import { FormSocialAuditRoutingModule } from './form-social-audit-routing.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { ComponentsModule } from 'src/app/components/components.module';
import { IConfig, NgxMaskModule } from 'ngx-mask';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    FormSocialAuditComponent
  ],
  imports: [
    CommonModule,
    FormSocialAuditRoutingModule,
    ReactiveFormsModule,
    MatDialogModule,
    ComponentsModule,
    NgxMaskModule.forRoot(maskConfig),
  ],
  exports: [
    FormSocialAuditRoutingModule
  ]
})
export class FormSocialAuditModule { }
